import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass([
         'visitor',
         'visitor-view',
         'grid--vertical',
       ])
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Enabled ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Disabled ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Blacklisted ")
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "binding-items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_visitor_profile = _resolveComponent("visitor-profile")!
  const _component_photo_taker = _resolveComponent("photo-taker")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_visiting_companies = _resolveComponent("visiting-companies")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_form_item, {
          label: _ctx.trans('label.status')
        }, {
          default: _withCtx(() => [
            (!_ctx.model.isDeleted && !_ctx.blacklisted)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "success"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.model.isDeleted)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.blacklisted)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 2,
                  type: "warning"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_visitor_profile, { model: _ctx.model }, null, 8, ["model"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_card, { class: "binding-item" }, {
              default: _withCtx(() => [
                _createVNode(_component_photo_taker, {
                  ref: "photoTaker",
                  model: _ctx.model,
                  preview: true
                }, null, 8, ["model"])
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_visiting_companies, {
          ref: "visitingCompanies",
          records: _ctx.visitCompanies
        }, null, 8, ["records"])
      ]))
    : (_openBlock(), _createBlock(_component_el_skeleton, {
        key: 1,
        rows: 10
      }))
}